var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftware(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h26.111v16.111H.5z",
    fill: "#335280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.721 16.111h11.667v4.445H7.72z",
    fill: "#CCA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.168 20.556h21.667V25H2.168z",
    fill: "#335280"
  })));
}
export default SvgSoftware;